const getEventTargetIndex = (event) => Number(event.currentTarget.dataset.index);

export default getEventTargetIndex;
